export default __webpack_public_path__ + "static/media/csharporg.0f57cf7b.png";